import React from 'react';
import { ArrowRight, HardHat, Eye, ClipboardCheck, Check } from 'lucide-react';
import { OVERSIGHT_ITEMS, IMAGES } from '../mock';

const ICONS = [HardHat, Eye, ClipboardCheck];

export default function Oversight() {
  return (
    <section id="nadzor" className="bg-white py-24 md:py-28">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="text-[12px] font-semibold tracking-[0.25em] text-[#0f1a2b]/60 mb-4">NADZÓR I KIEROWANIE ROBOTAMI</div>
        <div className="flex items-center gap-2 text-[13px] text-[#f5c518] font-semibold mb-3">
          <span className="inline-block h-2 w-2 rounded-full bg-[#f5c518]" /> Uprawnienia budowlane, bez ograniczeń
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-6">
            <h2 className="font-heading font-extrabold text-[36px] md:text-[46px] leading-[1.08] tracking-tight text-[#0f1a2b]">
              Nadzór i kierowanie robotami elektrycznymi
            </h2>
            <p className="mt-6 text-[15px] leading-relaxed text-[#0f1a2b]/75 max-w-xl">
              Wsparcie inwestorów i wykonawców podczas realizacji inwestycji, od kontroli dokumentacji i jakości prac po odbiory oraz weryfikację zgodności wykonania z projektem.
            </p>
            <div className="mt-8 rounded-2xl overflow-hidden">
              <img src={IMAGES.oversight} alt="Weryfikacja dokumentacji technicznej" className="w-full h-[360px] object-cover" />
            </div>
            <a href="#kontakt" className="mt-8 inline-flex items-center gap-2 text-[#0f1a2b] font-semibold text-[15px] group">
              Zapytaj o nadzór nad inwestycją
              <ArrowRight className="h-4 w-4 text-[#f5c518] transition-transform group-hover:translate-x-1" />
            </a>
          </div>

          <div className="lg:col-span-6 space-y-5">
            {OVERSIGHT_ITEMS.map((it, i) => {
              const Icon = ICONS[i];
              return (
                <div key={i} className="rounded-2xl bg-white border border-slate-200 p-7 hover-lift">
                  <div className="h-11 w-11 rounded-lg bg-[#132a44] flex items-center justify-center mb-5">
                    <Icon className="h-5 w-5 text-[#f5c518]" />
                  </div>
                  <h3 className="font-heading font-bold text-[19px] tracking-tight text-[#0f1a2b]">{it.title}</h3>
                  <p className="mt-3 text-[14px] leading-relaxed text-[#0f1a2b]/70">{it.desc}</p>
                  {it.bullets && (
                    <ul className="mt-4 space-y-2">
                      {it.bullets.map((b) => (
                        <li key={b} className="flex items-start gap-2 text-[14px] text-[#0f1a2b]/80">
                          <Check className="h-4 w-4 text-[#f5c518] mt-0.5 flex-shrink-0" />
                          <span>{b}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
